import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const Header = ({
    title,
    bodyCopy,
    headlineBackground,
    titleAlignment,
    titleTag,
    titleColor,
    titleFontFamily,
    bodyCopyTag,
    bodyCopyFontFamily
}) => {
    return (
        <Box width="100%" background={headlineBackground}>
            <Stack
                gap="10px"
                marginX="auto"
                textAlign={titleAlignment}
                paddingY={{base: '20px', md: '40px'}}
                paddingX={{base: '15px', md: '40px'}}
                maxWidth={titleAlignment === 'center' ? '700px' : '100%'}
            >
                {title && (
                    <Text
                        as={titleTag}
                        color={titleColor}
                        fontFamily={titleFontFamily}
                        lineHeight="normal"
                        fontSize={{base: '24px', md: '48px'}}
                        fontWeight="400"
                        letterSpacing={{base: '0.13px', lg: '0.24px'}}
                    >
                        {title}
                    </Text>
                )}
                {bodyCopy && (
                    <Text
                        as={bodyCopyTag}
                        color={titleColor}
                        fontFamily={bodyCopyFontFamily}
                        fontSize="16px"
                        lineHeight="25px"
                        letterSpacing={{base: '0.08px', lg: '0.085px'}}
                        fontWeight="300"
                    >
                        {bodyCopy}
                    </Text>
                )}
            </Stack>
        </Box>
    )
}

Header.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    headlineBackground: PropTypes.string,
    titleAlignment: PropTypes.string,
    titleTag: PropTypes.string,
    titleColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    bodyCopyTag: PropTypes.string,
    bodyCopyFontFamily: PropTypes.string
}

export default Header
